export const FIXTURE_DATA = [
  {
    title: 'Lets build Accordion',
    isParagraph: false,
    subheading: [
      {
        text: 'Hey let me know more about you.',
        key: 1,
      },
      {
        text: 'Lets plan something this weekend in Jio',
        key: 2,
      },
      {
        text: 'Lets Work Together!',
        key: 3,
      },
    ],
  },
  {
    title: 'Jio apps are made with React',
    isParagraph: true,
    subheading: 'Yeah I know it!. And Now?\nHey Rishav, Please optimise me!',
  },
]
